import React, { useState } from "react";

import { ISpacerPart } from "../../../../course-author/types";
import { CourseInstructionPartOperations } from "../CourseInstructionPart.types";
import {
  ColorFieldSet as ColourFieldSet,
  ColourInput,
  FlexFormContainer,
  PreviewBox,
  PreviewBoxContainer,
  SeparatorErrorMessage,
  SeparatorFieldSet,
  SpacerInput,
} from "./SpacerPart.styles";

interface ISpacerPartProps {
  spacerPart: ISpacerPart;
  edit: boolean;
  partOperations: CourseInstructionPartOperations;
}

export const SpacerPart: React.FC<ISpacerPartProps> = props => {
  const {
    partOperations,
    edit,
    spacerPart: {
      content: { settings },
    },
  } = props;

  const [height, setHeight] = useState(settings.height);
  const [color, setColor] = useState(settings.color);
  const [errorMessage, setErrorMessage] = useState("");

  const onSpacerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) < 0) {
      setErrorMessage("Height must be greater than 0");
      return;
    }

    if (e.target.value === "") {
      setErrorMessage("Please enter a height");
      return;
    }

    setErrorMessage("");
    setHeight(Number(e.target.value));
    partOperations.editSpacer({
      settings: { height: Number(e.target.value), color },
    });
  };

  const onColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setColor(e.target.value);
    partOperations.editSpacer({ settings: { height, color: e.target.value } });
  };

  return (
    <>
      {edit ? (
        <>
          <SeparatorErrorMessage data-testid="spacer-error">{errorMessage}</SeparatorErrorMessage>
          <FlexFormContainer data-testid="spacer">
            <SeparatorFieldSet data-testid="spacer-height">
              <legend>Height</legend>
              <SpacerInput
                name="height"
                placeholder="Enter amount"
                type="number"
                defaultValue={String(height)}
                onBlur={onSpacerChange}
              />
            </SeparatorFieldSet>
            <ColourFieldSet data-testid="spacer-color">
              <legend>Colour</legend>
              <ColourInput
                name="colour"
                placeholder="Colour"
                type="color"
                defaultValue={color}
                onChange={onColorChange}
              />
            </ColourFieldSet>
          </FlexFormContainer>
        </>
      ) : (
        <PreviewBoxContainer>
          <PreviewBox height={height} color={color} />
        </PreviewBoxContainer>
      )}
    </>
  );
};
